<template>
  <div class="wf-variables-table">
    <WfVariablesTableBanner
      v-if="showBanner"
      message="You can now sync multiple variable collections and modes to Webflow."
      color="#D7A220"
      @close="setVariablesV2AnnouncementRead(true)"
    />
    <WfVariableLibrary v-for="library in libraries" :key="library.id" :library="library" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import WfVariablesTableBanner from './variablesTable/WfVariablesTableBanner.vue';
import WfVariableLibrary from './variablesTable/WfVariableLibrary.vue';
import { getClientStorage, setClientStorage } from '@/figma/clientstorage';

const store = useStore();

const hasLoaded = ref(false);

const showBanner = computed(
  () => (hasLoaded.value && !store.state.variable.variablesV2AnnouncementRead) || false
);

const libraries = computed(() => store.state.variable.libraries);

const setVariablesV2AnnouncementRead = (value) => {
  setClientStorage('variablesV2AnnouncementRead', value);
  store.commit('variable/setVariablesV2AnnouncementRead', value);
};

onMounted(() => {
  getClientStorage('variablesV2AnnouncementRead').then((value) => {
    store.commit('variable/setVariablesV2AnnouncementRead', value || false);
    hasLoaded.value = true;
  });
});
</script>
